// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e68bdd76","239":"f9fd5667","453":"eb925897","455":"1353cf3b","884":"bdf15372"}[chunkId] + ".chunk.js";
};